<template> 
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <div>
          <v-tabs v-model="tab">
            <v-tab>Server Data</v-tab>
            <v-tab v-if="statusOffline">Local Data</v-tab>
            <v-spacer/>
            <v-btn icon color="green" dark :to="{name:'tes/survey/respon/form', query:{jilid_id:$route.query.jilid_id}}"><v-icon>add</v-icon></v-btn>                      
            <v-menu bottom left>
              <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
              <v-list>
                <v-list-tile v-bind:to="{path:'/tes/survey/respon/rekap', query:$route.query}">
                  <v-list-tile-title>Rekap</v-list-tile-title>
                </v-list-tile>                       
              </v-list>
            </v-menu> 
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card>
                <v-toolbar flat>      
                  <v-text-field flat dense filled
                    v-model="term"                    
                    label="Search"
                    single-line
                    hide-details        
                    @input="search"
                    style="max-width:200px"
                  ></v-text-field>                             
                  <v-btn icon color="blue-grey" dark :loading="loading" @click="readItems"><v-icon>find_replace</v-icon></v-btn>
                  <v-btn-toggle class="mr-3" v-model="toggle_gender" multiple dark>
                    <v-btn small flat class="red white--text" :value="1">L</v-btn>
                    <v-btn small flat class="blue-grey white--text"  :value="2">P</v-btn>              
                  </v-btn-toggle>  
                  <v-btn-toggle v-model="toggle_tingkat" class="mr-3" multiple dark>                
                    <v-btn round small v-for="(tingkat,i) in tingkats" :key="i" :value="tingkat.id" :color="getColor(tingkat.id)">{{tingkat.nama}}</v-btn>                
                  </v-btn-toggle> 
                </v-toolbar>
                <v-card-text class="pa-0">      
                  <v-container fluid grid-list-lg class="ma-0 pa-0">
                    <v-layout row>
                      <v-flex xs12 md12 style="position:relative">            
                        <v-data-table dense 
                          :headers="headers"
                          :items="items"              
                          :loading="loading"
                          loading-text="Loading... Please wait"
                          :items-per-page="-1"
                          hide-default-footer  
                          hide-actions
                          :options.sync="pagination" 
                          must-sort                       
                        > 
                          <template slot="items" slot-scope="props">
                            <td>{{ ((page-1)*20)+(items.findIndex(x=>x==props.item)+1) }}</td>
                            <td>{{ $moment(props.item.created_at*1000).format('DD/MM/YYYY') }}</td>
                            <td>{{ props.item.code }}</td>
                            <td>{{ props.item.responden.nama }}({{props.item.responden.gender == 1 ? 'L':'P'}})</td>
                            <td v-if="tingkats.length > 0">{{ tingkats.find(x=>x.id===props.item.responden.jurusan_id) ? tingkats.find(x=>x.id===props.item.responden.jurusan_id).description : tingkats.find(x=>x.id===props.item.responden.tingkat_id).description}}</td>                  
                            <td>{{ props.item.responden.telepon }}</td>
                            <td>{{ props.item.responden.ayah_nama }}</td>
                            <td>{{ props.item.responden.ibu_nama }}</td>
                            <td>{{ props.item.createdby.username }}</td>
                            <td><v-btn icon small color="blue" :to="{name:'tes/survey/respon/form',query:{jilid_id:$route.query.jilid_id,id:props.item.id}}"><v-icon>edit</v-icon></v-btn></td>
                          </template>                                        
                        </v-data-table>
                        <div class="text-center">
                          <v-pagination
                            v-model="page"
                            :length="totalPages"
                            circle
                            :total-visible="9"
                          ></v-pagination>
                        </div>
                      </v-flex>          
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card> 
            </v-tab-item>      
          </v-tabs-items>
        </div>  
      </v-container>
    </div>
  </v-slide-y-transition>      
</template>

<script>
import { debounce } from 'lodash'
import model from '@/apps/admin/models/master/Respon'

export default {  
  data () {
    return {
      tab : 0,
      term : null,
      headers:[
        {text:'No', value:'no'},        
        {text:'Date', value:'date'},
        {text:'Code', value:'code'},
        {text:'Name', value:'responden.nama'},
        {text:'Tingkat', value:'responden.tingkat_id'},
        {text:'Phone', value:'responden.telepon'},
        {text:'Nama Ayah', value:'responden.ayah_nama'},   
        {text:'Nama Ibu', value:'responden.ibu_nama'},   
        {text:'Surveyor', value:'createdby.username'},     
        {text:'#', value:'action'}
      ],
      items: [],     
      pagination:{sortBy:[]},
      page : 1,      
      totalPages: 0,      
      loading: false,    
      toggle_tingkat : [],
      toggle_gender : [], 
      tingkats :[], 
    }
  },
  computed:{
    status(){
      return {0:'active',1:'inactive'};      
    }, 
    statusOffline(){
      return false;
    }   
  },
  watch:{
    page(newPage){
      this.readItems(newPage) 
    },
    pagination:{
      handler(){
        this.readItems(this.page) 
      }, deep:true      
    },
    toggle_tingkat(newArr){
      let tingkat = [], jurusan = [];
      newArr.forEach(ar=>{
        if(ar <= 3){tingkat.push(ar);} 
        else if(ar === 7){tingkat.push(ar);}
        else{jurusan.push(ar);}
      });                
      this.readItems(this.page, this.toggle_gender, tingkat, jurusan);        
    },
    toggle_gender(newArr){ 
      let tingkat = [], jurusan = [];
      this.toggle_tingkat.forEach(ar=>{
        if(ar <= 3){tingkat.push(ar);} 
        else if(ar === 7){tingkat.push(ar);}
        else{jurusan.push(ar);}
      });                
      this.readItems(this.page, newArr, tingkat, jurusan);        
    },
  },  
  created () {
    this.readItems()
  },
  mounted(){
    this.tab = this.statusOffline ? 1 : 0;
    model.tingkats().then(data=>{this.tingkats = data});
      
  },
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    readItems (page = 0, gender='', tingkat_id='', jurusan_id='') {
      this.loading = true; this.items = [];
      
      let  sortby = this.pagination.sortBy[0] ? this.pagination.sortDesc[0] ? 
        '-'+this.pagination.sortBy[0] : this.pagination.sortBy[0] : 'id';                          
      
      const params = {
        perPage: 20,
        page: page,
        q: this.term,
        jilid_id: this.$route.query.jilid_id,
        sort:sortby,
        gender: gender,
        tingkat_id: tingkat_id,
        jurusan_id: jurusan_id,            
        expand:'createdby,responden'
      }

      model.index(params)
        .then(response => {
          this.items = response.data;
          this.totalPages = response.pagination.pageCount;               
          this.loading = false
        })
    },    

    getColor(tingkat){
      switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; case 7:return 'light-green'; default:return 'blue-grey';}
    },
  },  
}
</script>